
export const SET_ERROR_ORDER_SUCCESS = 'error/SET_ERROR_ORDER_SUCCESS';

const initialState = {
    errorOrderFlag: false,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_ERROR_ORDER_SUCCESS:
            return {
                ...state,
                errorOrderFlag: action.payload,
            };

        default:
            return state;
    }
};


export const setErrorOrderFlag = (data) => ({
    type: SET_ERROR_ORDER_SUCCESS,
    payload: data,
});